import { motion } from "framer-motion";
import { Check, Sparkles, Heart } from "lucide-react";

export const CompletionScreen = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50 dark:from-slate-900 dark:via-slate-800 dark:to-blue-900/20 flex items-center justify-center p-4">
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="text-center space-y-8 max-w-md"
            >
                {/* Success Icon */}
                <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 0.2, type: "spring", stiffness: 300, damping: 20 }}
                    className="mx-auto w-20 h-20 bg-gradient-to-r from-green-400 to-green-600 rounded-full flex items-center justify-center shadow-lg"
                >
                    <Check className="w-10 h-10 text-white" />
                </motion.div>

                {/* Floating Elements */}
                <div className="relative">
                    {[...Array(6)].map((_, i) => (
                        <motion.div
                            key={i}
                            className="absolute"
                            initial={{ opacity: 0, scale: 0 }}
                            animate={{ 
                                opacity: [0, 1, 0],
                                scale: [0, 1, 0],
                                x: [0, (i % 2 ? 1 : -1) * (30 + i * 10)],
                                y: [0, -20 - i * 5]
                            }}
                            transition={{
                                duration: 2,
                                delay: 0.5 + i * 0.2,
                                repeat: Infinity,
                                repeatDelay: 3
                            }}
                            style={{
                                left: `${50 + (i % 2 ? 1 : -1) * (i * 15)}%`,
                                top: "50%"
                            }}
                        >
                            {i % 3 === 0 ? (
                                <Sparkles className="w-4 h-4 text-yellow-500" />
                            ) : i % 3 === 1 ? (
                                <Heart className="w-4 h-4 text-pink-500" />
                            ) : (
                                <div className="w-2 h-2 bg-blue-500 rounded-full" />
                            )}
                        </motion.div>
                    ))}
                </div>

                {/* Title and Description */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4 }}
                    className="space-y-4"
                >
                    <h2 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-slate-100">
                        Parabéns! 🎉
                    </h2>
                    <p className="text-lg text-slate-600 dark:text-slate-400">
                        Avaliação completada com sucesso
                    </p>
                    <p className="text-sm text-slate-500 dark:text-slate-500">
                        Analisando suas respostas e preparando seus resultados personalizados...
                    </p>
                </motion.div>

                {/* Loading Animation */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.6 }}
                    className="space-y-4"
                >
                    <div className="flex justify-center space-x-1">
                        {[...Array(3)].map((_, i) => (
                            <motion.div
                                key={i}
                                className="w-3 h-3 bg-gradient-to-r from-primary-400 to-blue-500 rounded-full"
                                animate={{
                                    scale: [1, 1.2, 1],
                                    opacity: [0.7, 1, 0.7]
                                }}
                                transition={{
                                    duration: 1,
                                    delay: i * 0.2,
                                    repeat: Infinity,
                                    ease: "easeInOut"
                                }}
                            />
                        ))}
                    </div>
                    <motion.div
                        className="w-48 h-1 bg-slate-200 dark:bg-slate-700 rounded-full mx-auto overflow-hidden"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.8 }}
                    >
                        <motion.div
                            className="h-full bg-gradient-to-r from-primary-500 to-blue-500 rounded-full"
                            initial={{ width: "0%" }}
                            animate={{ width: "100%" }}
                            transition={{ 
                                duration: 2.5,
                                delay: 1,
                                ease: "easeInOut"
                            }}
                        />
                    </motion.div>
                </motion.div>

                {/* Completion Message */}
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 1.2 }}
                    className="text-xs text-slate-400 dark:text-slate-600"
                >
                    Aguarde enquanto processamos sua avaliação
                </motion.div>
            </motion.div>
        </div>
    );
}; 